<template>
    <div class="text-margin">
        <el-form-item/>
    </div>
</template>

<script>

export default {
    name: 'FormWeChat.vue',
    
    data() {
        return {

        }
    },
    created(){

    },
    mounted(){
    },
    methods: {
        
    }
}
</script>

<style scoped>

</style>
